import { action, observable } from 'mobx';

import { fetchDonations } from '~api/DonationsAPI/DonationsAPI';

import { IDonation, IDonationPriceRange } from '~domain/entities/Donation/IDonation';

export default class DonationsController {
    @observable public donations: IDonation[];
    @observable public selectedDonation: IDonation | undefined;
    @observable public selectedPrice: IDonationPriceRange;
    @observable public error = null;

    @action public setDonations = (donations: IDonation[]) => {
        this.donations = donations;
    };
    @action public setSelectedDonation = (selectedDonation: IDonation | undefined) => {
        this.selectedDonation = selectedDonation;
    };
    @action public setSelectedPrice = (price: IDonationPriceRange) => {
        this.selectedPrice = price;
    };

    @action public fetchDonations = () => {
        fetchDonations().then((fetchedDonations) => {
            this.setDonations(fetchedDonations);
            this.setSelectedDonation(fetchedDonations[0]);
            this.setSelectedPrice(fetchedDonations[0].prices[0]);
        });
    };
}
